import { render, staticRenderFns } from "./AddrPopup.vue?vue&type=template&id=ca58d288&scoped=true"
import script from "./AddrPopup.vue?vue&type=script&lang=ts"
export * from "./AddrPopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca58d288",
  null
  
)

export default component.exports